<template>
  <div class="tiger-help">
    <div class="tiger-help-page">
      <go-to-top />
      <div v-if="currentPage.key === 'responsible'" class="rg-hero">
        <div class="rg-brand">
          TIGER CASINO
        </div>
        <div class="rg-hero-title">
          責任あるギャンブルについて
        </div>
        <div class="rg-hero-caption">
          PLAY RESPONSIBLY
        </div>
      </div>
      <div v-else class="help-hero">
        <img :src="$getThemeImagePath(currentPage.banner)" :alt="currentPage.title">
      </div>

      <div class="page-tabs" role="navigation" aria-label="ヘルプページの切り替え">
        <router-link
          v-for="tab in tabs"
          :key="tab.key"
          :to="tabLink(tab.key)"
          :class="{ active: activeTab === tab.key }"
          :aria-current="activeTab === tab.key ? 'page' : null"
        >
          {{ tab.label }}
        </router-link>
      </div>

      <div class="mainhead">
        <h1>{{ currentPage.title }}</h1>
        <p v-if="currentPage.lead">
          {{ currentPage.lead }}
        </p>
      </div>

      <tiger-faq v-if="currentPage.key === 'faq'" />
      <tiger-payments v-else-if="currentPage.key === 'payments'" />
      <tiger-wallet v-else-if="currentPage.key === 'wallet'" />
      <tiger-swap v-else-if="currentPage.key === 'swap'" />
      <tiger-self-restraint v-else-if="currentPage.key === 'limit'" :responsible-link="tabLink('responsible')" />
      <tiger-responsible v-else-if="currentPage.key === 'responsible'" :limit-link="tabLink('limit')" />
      <div v-else ref="legal" class="help-legal">
        <div class="panel update-panel">
          <p>最終更新日：2026年10月1日</p>
        </div>
        <div class="doc-index" role="navigation" aria-label="目次">
          <a v-for="item in docIndex" :key="item.id" :href="`#${item.id}`" @click.prevent="scrollToSection(item.id)">
            {{ item.title }}
          </a>
        </div>
        <tiger-terms v-if="currentPage.key === 'terms'" />
        <tiger-promo v-else />
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import TigerFaq from './tigerFaq.vue'
import TigerPayments from './tigerPayments.vue'
import TigerWallet from './tigerWallet.vue'
import TigerSwap from './tigerSwap.vue'
import TigerSelfRestraint from './tigerSelfRestraint.vue'
import TigerResponsible from './tigerResponsible.vue'
import TigerTerms from './tigerTerms.vue'
import TigerPromo from './tigerPromo.vue'

// 上方分頁；責任あるギャンブル 不在分頁列上，從自己規制進入，分頁列維持亮在自己規制
const pages = [
  { key: 'faq', label: 'よくある質問', title: 'よくある質問', lead: 'ご不明な点はカテゴリーからご確認ください。', banner: 'sup/help/banner_faq.webp' },
  { key: 'payments', label: '入出金', title: '入出金', lead: '仮想通貨での入金・出金操作を画像でご案内します。', banner: 'sup/help/banner_payments.webp' },
  { key: 'wallet', label: 'ウォレットについて', title: 'ウォレットについて', lead: '各ウォレットの使い方と残高の管理方法をご案内します。', banner: 'sup/help/banner_wallet.webp' },
  { key: 'swap', label: 'ウォレット振替について', title: 'ウォレット振替の利用', lead: 'スワップ機能を利用したウォレット間の資金移動についてご案内します。', banner: 'sup/help/banner_swap.webp' },
  { key: 'limit', label: '自己規制', title: '自己規制', banner: 'sup/help/banner_limit.webp' },
  { key: 'terms', label: '利用規約', title: '利用規約', banner: 'sup/help/banner_terms.webp' },
  { key: 'promo', label: 'プロモーション一般利用規約', title: 'プロモーション一般利用規約', banner: 'sup/help/banner_promo.webp' },
  { key: 'responsible', title: '責任あるギャンブルについて', tab: 'limit' }
]

export default {
  name: 'SupportTiger',
  components: {
    goToTop,
    TigerFaq,
    TigerPayments,
    TigerWallet,
    TigerSwap,
    TigerSelfRestraint,
    TigerResponsible,
    TigerTerms,
    TigerPromo
  },
  data() {
    return {
      docIndex: []
    }
  },
  computed: {
    tabs() {
      return pages.filter(page => page.label)
    },
    currentPage() {
      return pages.find(page => page.key === this.$route.query.tab) || pages[0]
    },
    activeTab() {
      return this.currentPage.tab || this.currentPage.key
    }
  },
  watch: {
    'currentPage.key': {
      immediate: true,
      handler(key, oldKey) {
        if (oldKey) {
          window.scrollTo({ top: 0 })
        }
        this.$nextTick(this.updateDocIndex)
      }
    }
  },
  methods: {
    tabLink(key) {
      return { path: this.$route.path, query: key === 'faq' ? {} : { tab: key }}
    },
    // 目次直接讀條款內文的章節標題，不另外維護一份標題清單
    updateDocIndex() {
      const legal = this.$refs.legal
      this.docIndex = legal
        ? Array.from(legal.querySelectorAll('.legal-section')).map(section => ({
          id: section.id,
          title: section.querySelector('.terms-title').textContent.trim()
        }))
        : []
    },
    scrollToSection(id) {
      const target = document.getElementById(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>

<style src="@/assets/css/support-tiger.css"></style>
